<template>
  <div class="memory">
    <keep-alive v-if="ifKeepAlive">
      <router-view></router-view>
    </keep-alive>
    <router-view v-if="!ifKeepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "memory",
  beforeRouteUpdate(to, from, next) {
    // if (from.path != "/") {
    //   // 如果不是刷新则赋值1
    //   sessionStorage.removeItem("myCurrentPage");
    // }
    // console.log(to, from, next)
    if (
      (to.name === "termBank" && from.name != "memoryBank") ||
      (to.name === "memoryBank" && from.name != "termBank")
    ) {
      this.ifKeepAlive = true;
    } else {
      this.ifKeepAlive = false;
    }
    next();
  },
  data() {
    return {
      ifKeepAlive: false
    };
  },
  created() {
    // alert(this.$route.meta.keepAlive)
  },
  watch: {
    // '$route' (to, from) {
    //   this.$index.go(0);
    // }
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.memory {
  height: 100%;
  // overflow: hidden;
  // padding: 10px;
}
</style>
